import rpcCall from "../../../util/rpc/rpcCalls"
import {isOlVersion, UserManagementConstants} from "../../../constants"
import * as UserDataActions from '../userData/actions'
import {
    managementAssignmentsCountsLoad,
    managementAssignmentsCountsLoadFailure,
    managementAssignmentsCountsLoadSuccess,
    setTimeZoneGroupData,
    setUserGroupData,
    updateStateFromViewerSettings
} from '../userData/actions'
import {createAction} from 'redux-actions'
import {
    calculateProjectsByCustomerIds,
    convertManageAssignmentsToArrays,
    createManagementAssignmentsData,
    getAssignedUsersCount,
    getTaskIdsOfCustomersAndProjects,
    makeDefaultUserAccountSettings,
    mergeAssignments
} from "./utils"
import {
    validateEmail,
    validateFirstName,
    validateHireDate,
    validateLastName,
    validatePassword,
    validateTimezoneGroup,
    validateUserGroupName,
    validateUserName
} from "../validation"
import {
    getAllUsers,
    getFullUserInfo,
    getTimeZoneGroupRowData,
    getUserDataState,
    getUserGroupRowData,
    getUserPanelErrors,
    getUserRatesValidationData
} from "../userData/selectors"
import {getManageAssignments, getManageAssignmentsTasks, getManagementAssignmentsCptIds, isUserDataChanged, isUserCreated} from "./selectors"
import _ from "underscore"
import {createActionObject} from "../../../redux/utils"
import * as ActionTypes from "./actionTypes"
import {getCustomers, getProjects, getTasks} from "../../../entities/selectors"
import * as SyncCallbacks from "./syncCallbacks"
import {EXCEPTIONS} from "../editPanel/util"
import {convertManagementAssignmentsDataFromRpc, getTimeZoneOffsets} from "../utils"
import messageResource from "../../../messageResource"
import {addTimeZoneGroups, addUser, addUserGroups} from "../../../entities/actions"
import {
    addNewUserIds,
    closeAllPanels,
    setLicenseCounters, setUserManagementData,
    setUsersWithoutApprovers,
    setViewerSettings
} from "../../../administration/userManagement/common/actions"
import {setEnabledFeatures} from "../../../features/actions"
import {prependUserIdsOrder, setWorkAssignmentsCountersForUser} from "../../../administration/userManagement/workAssignmentsTab/actions"
import {GROUP_NEW_OR_NOT_KNOWN, TabKeys, UserTeamAssignmentType, ValidationErrors} from "../constants"
import $ from 'jquery'
import ExitConfirmationHandlersManager from '../../../ExitConfirmationHandlersManager'
import {DEFAULT_TIME_ZONE_GROUP_ID, ManagementAssignmentsSelection, USERS_WITHOUT_GROUP_ID} from 'constants'
import {getErrors, getUserRates} from '../accountSettings/userRates/selectors'
import {getUserRatesErrors, getValidRates, isInitialScheduleValid,} from '../accountSettings/userRates/validationUtils'
import * as AuthorizationInfoActions from '../authorizationInfo/actions'
import * as UserRatesActions from '../accountSettings/userRates/actions'
import {isTZGEnabled, isUGREnabled, isURAEnabled} from '../../../features/selectors'
import {AdditionalDataConstants} from '../../../administration/userManagement/constants'
import {getDefaultWorkSchedule, getUserManagementData} from '../../../administration/userManagement/common/selectors'
import {arrayToSet} from '../../../atUtils'
import {DEFAULT_MANAGEMENT_ASSIGNMENTS, DEFAULT_TEAM_ASSIGNMENTS} from './constants'
import {canAccessManagersScope} from '../../../util/accessRightsUtils'

export const setLoading = createAction(ActionTypes.LOADING_SET)

export const resetPanelState = createAction(ActionTypes.RESET_CREATE_USER_PANEL_STATE)

export const setUserPanelTab = createAction(ActionTypes.CREATE_USER_PANEL_TAB_SET)

export const setManageAssignments = createAction(ActionTypes.MANAGE_ASSIGNMENTS_SET)
export const setCustomersCount = createAction(ActionTypes.CUSTOMERS_COUNT_SET)
export const setProjectsOfCustomerCount = createAction(ActionTypes.PROJECTS_COUNT_SET)
export const setTasksOfProjectCount = createAction(ActionTypes.TASKS_COUNT_SET)

export const addTasksManageAssignments = createAction(ActionTypes.MANAGE_ASSIGNMENTS_TASKS_ADD)

export const setShowFutureInvitation = createAction(ActionTypes.SHOW_FUTURE_INVITATION_SET)

export const setLoaded = createAction(ActionTypes.LOADED_SET)

const setDefaultUserInfo = createAction(ActionTypes.DEFAULT_USER_INFO_SET)
const setDefaultTeamAssignments = createAction(ActionTypes.DEFAULT_TEAM_ASSIGNMENTS_SET)
const setDefaultManageAssignments = createAction(ActionTypes.DEFAULT_MANAGE_ASSIGNMENTS_SET)
export const setPasswordValidationRequested = createAction(ActionTypes.PASSWORD_VALIDATION_REQUESTED)
export const setPasswordValidationDone = createAction(ActionTypes.PASSWORD_VALIDATION_DONE)


export const setCopyUserId = createAction(ActionTypes.COPY_USER_CHANGED)

const setUpExitConfirmation = (getState) => {
    ExitConfirmationHandlersManager.setUpExitConfirmation(messageResource.getMessage('user.add.js.cancel_confirmation'), () => {
        return isUserDataChanged(getState())
    }, false)
}

export const openCreateUserPanel = () => (dispatch, getState) => {
    setUpExitConfirmation(getState)
    dispatch(setLoaded(false))
    dispatch(createActionObject(ActionTypes.TOGGLE_CREATE_USER_PANEL, true))
}

export const inviteOneMoreUser = () => (dispatch) => {
    dispatch(setLoaded(false))
    dispatch(resetPanelState())
}

export const loadCreateUserPanelData = () => (dispatch, getState) => {
    dispatch(setLoading(true))

    rpcCall(
        "UserManagementService.getCreateUserData", []
    ).then((createData) => {
        const state = getState()
        dispatch(setLoaded(true))

        const defaultAccountSetting = {
            ...makeDefaultUserAccountSettings(createData.userManagementData, createData.showAPStatusControl),
            password: null,
            retypedPassword: null,
        }

        const allTimeZoneGroupOffsets =  getTimeZoneOffsets(createData.userManagementData.allTimeZoneGroups)
        const userGroupRowData = {
            groupId: UserManagementConstants.USER_GROUP_NOT_ASSIGNED_ID,
            newGroupCreating: false,
        }
        const  timeZoneGroupRowData = {
            groupId: UserManagementConstants.DEFAULT_TIME_ZONE_GROUP_ID,
            newGroupCreating: false,
            timeZoneGroupsOffset: allTimeZoneGroupOffsets,
            newTimeZoneGroup: null,
        }
        const userData = {
            ...defaultAccountSetting,
            manageAssignments: {
                managementAssignmentsSelection: ManagementAssignmentsSelection.SELECTED,
                addedTaskIds: [],
                addedProjectIds: [],
                addedProjectIdsExcludingSelf: [],
                addedCustomerIds: [],
                addedCustomerIdsExcludingSelf: [],
                taskCountsByProjects: {},
                projectCountsByCustomers: {}
            },
            teamAssignments: {
                teamAssignmentType: UserTeamAssignmentType.SELECTED,
                assignedGroups: [],
                assignedUsers: [],
            },
            approversByGroups: createData.approversByGroups.map,
            userManagementData: {
                userGroups: createData.userManagementData.allUserGroups,
                timeZoneGroups: createData.userManagementData.allTimeZoneGroups,
            }
        }

        const extendedData = {
            currentTime: createData.currentTimeInDefaultTimeZone,
        }
        const userManageAssignmentsData = createManagementAssignmentsData(
            userData.manageAssignments,
            getCustomers(state),
            getProjects(state),
            {}
        )

        const userTeamAssignmentsData = {
            teamAssignmentType: UserTeamAssignmentType.SELECTED,
            assignedGroups: [],
            assignedUsers: [],
            assignedUsersCount: 0,
        }

        if (createData.userManagementData.allUserGroups) {
            dispatch(addUserGroups(createData.userManagementData.allUserGroups))
        }
        if (createData.userManagementData.allTimeZoneGroups) {
            dispatch(addTimeZoneGroups(createData.userManagementData.allTimeZoneGroups))
        }
        dispatch(updateStateFromViewerSettings(createData.userManagementData.viewerSettings))

        dispatch(UserDataActions.setUserData({
            ...createData,
            fullUserInfo: defaultAccountSetting,
            userGroupRowData,
            timeZoneGroupRowData,
            allApprovers: createData.approversByGroups.map[UserManagementConstants.USER_GROUP_NOT_ASSIGNED_ID],
            userManageAssignmentsData,
            userTeamAssignmentsData,
            extendedData,
            providerErrors: {}
        }))
        dispatch(createActionObject(ActionTypes.CREATE_USER_PANEL_TAB_SET, TabKeys.ACCOUNT_SETTINGS))

        dispatch(managementAssignmentsCountsLoadSuccess({
            customers: 0,
            projects: 0,
            tasks: 0,
        }))

        dispatch(AuthorizationInfoActions.setAuthorizationInfo(createData.authorizationInfo))

        dispatch(setDefaultUserInfo(defaultAccountSetting))
        dispatch(setDefaultTeamAssignments(userTeamAssignmentsData))
        dispatch(setDefaultManageAssignments(userData.manageAssignments))
        dispatch(createActionObject(ActionTypes.APPROVERS_BY_GROUPS_SET, createData.approversByGroups.map))
        dispatch(setUserManagementData(createData.userManagementData))

        dispatch(setLoading(false))
    }).catch(data => {
        dispatch(setLoading(false))
        console.error(data)
        dispatch(createActionObject(ActionTypes.TOGGLE_CREATE_USER_PANEL, false))
    })
}

export const closeCreateUserPanel = () => (dispatch) => {
    ExitConfirmationHandlersManager.restoreExitConfirmation()
    dispatch(createActionObject(ActionTypes.TOGGLE_CREATE_USER_PANEL, false))
    dispatch(setLoaded(false))
    dispatch(resetPanelState())
    dispatch(UserDataActions.clearUserPanelErrors())
    dispatch(UserDataActions.setPasswordValidationResult(null))
    SyncCallbacks.onCreateUserPanelClosed()
}

export const cancelUserCreation =  () => (dispatch, getState) => {
    const state = getState()
    const dataChanged = isUserDataChanged(state)

    if (isUserCreated(getState()) || (!dataChanged  || confirmCancelUserCreation())) {
        dispatch(UserDataActions.clearUserPanelErrors())
        dispatch(UserRatesActions.clearErrors())
        dispatch(closeAllPanels())
    }
}

const confirmCancelUserCreation = () => {
    return confirm(messageResource.getMessage('user.add.js.cancel_confirmation'))
}

export const validateAndSaveUser = () => (dispatch, getState) => {
    const state = getState()
    const uraEnabled = isURAEnabled(state)

    let isUserRatesValid = false

    if (uraEnabled) {
        const rates = getUserRates(state)
        const {overtimeEnabled, leaveTypesEnabled} = getUserRatesValidationData(state)
        const {isValid, errors} = getUserRatesErrors(rates, overtimeEnabled, leaveTypesEnabled, false)
        isUserRatesValid = isValid
        dispatch(updateValidateUserRatesResult(isValid))
        dispatch(UserRatesActions.setErrors(errors))
    }

    const initialSchedule = getFullUserInfo(state).initialSchedule
    const isWorkScheduleValid = isInitialScheduleValid(initialSchedule)

    dispatch(updateValidateWorkScheduleResult(isWorkScheduleValid))

    if ((!uraEnabled || isUserRatesValid) && isWorkScheduleValid) dispatch(saveUser())
}

export const saveUser = (force = false) => (dispatch, getState) => {
    const state = getState()
    const userInfo = getFullUserInfo(state)
    const userGroupData = getUserGroupRowData(state)
    const timeZoneGroupData = getTimeZoneGroupRowData(state)
    const providerErrors = getUserPanelErrors(state)

    const validationResult = validateUserForCreate(userInfo, userGroupData, timeZoneGroupData, providerErrors)

    if (validationResult.isValid) {
        if (isOlVersion) {
            getCurrentTimeInfo(userInfo.timeZoneGroupId)
                .then(currentTimeInfo => {
                    //hire date isn't in future
                    if (force || userInfo.hireDate.parseJSONDate().getTime() <= currentTimeInfo.currentTime.parseJSONDate().getTime()) {
                        dispatch(saveUserWithoutHireDateCheck())
                    } else {
                        dispatch(setUserPanelTab(TabKeys.ACCOUNT_SETTINGS))
                        dispatch(setShowFutureInvitation(true))
                    }
                })
        } else {
            // no need to check hire date in downloadable version
            dispatch(saveUserWithoutHireDateCheck())
        }
    } else {
        dispatch(UserDataActions.setUserPanelErrors(validationResult.providerErrors))
    }
}

export const updateValidateUserRatesResult = (isValid) => (dispatch) => {
    if (isValid) {
        dispatch(UserDataActions.removeUserPanelErrors([ValidationErrors.USER_RATES_ERROR]))
    } else {
        dispatch(UserDataActions.addUserPanelErrors([ValidationErrors.USER_RATES_ERROR]))
    }
}

export const updateValidateWorkScheduleResult = (isValid) => (dispatch) => {
    if (isValid) {
        dispatch(UserDataActions.removeUserPanelErrors([ValidationErrors.WORK_SCHEDULE_ERROR]))
    } else {
        dispatch(UserDataActions.addUserPanelErrors([ValidationErrors.WORK_SCHEDULE_ERROR]))
    }
}

const saveUserWithoutHireDateCheck = () => (dispatch, getState) => {
    const state = getState()

    const uraEnabled = isURAEnabled(state)
    const userData = getUserDataState(state)
    const userInfo = userData.fullUserInfo
    const userGroupData = getUserGroupRowData(state)
    const timeZoneGroupData = getTimeZoneGroupRowData(state)

    const manageAssignments = canAccessManagersScope(userInfo) ? getManageAssignments(state) : DEFAULT_MANAGEMENT_ASSIGNMENTS
    const teamAssignments = canAccessManagersScope(userInfo) ? userData.userTeamAssignmentsData : DEFAULT_TEAM_ASSIGNMENTS

    dispatch(createActionObject(ActionTypes.SAVE_USER))

    let accountSettings = pickAccountSettingsForCreateUser(state, userData.fullUserInfo)

    if (uraEnabled) {
        const {leaveTypesEnabled} = getUserRatesValidationData(state)
        accountSettings = {
            ...accountSettings,
            rates: getValidRates({rates: accountSettings.rates, leaveTypesEnabled, overtimeEnabled: false})
        }
    }

    rpcCall(
        "UserManagementService.createUser", [
            accountSettings,
            userGroupData.newUserGroupName,
            timeZoneGroupData.newTimeZoneGroup,
            (userInfo.password) ? (userInfo.password) : null,
            teamAssignments,
            manageAssignments
        ], (error) => {
            const errorThrown = error.getErrorThrown()
            error.handleOnException(EXCEPTIONS.DuplicateTimeZone, {
                _providerStatus: ValidationErrors.DUPLICATE_TIME_ZONE_GROUP,
                timeZones: errorThrown.timeZones,
            });
            error.handleOnException(EXCEPTIONS.UserEmailInvalidException, {_providerStatus: ValidationErrors.EMAIL_INVALID});
            error.handleOnException(EXCEPTIONS.UserExistsException, {_providerStatus: ValidationErrors.DUPLICATE_USERNAME});
        }
    ).then((createUserResult) => {
        if (_.isUndefined(createUserResult.resultCode) || createUserResult.resultCode === UserManagementConstants.RESULT_CODE_SUCCESS) {
            const additionalData = createUserResult.additionalResultData.map
            if (isOlVersion) {
                dispatch(UserDataActions.setFullUserInfo(createUserResult.userInfo))
                dispatch(createActionObject(ActionTypes.SAVE_USER_SUCCESS, {
                    invitationSent: additionalData.invitationSent
                }))
            } else {
                dispatch(closeCreateUserPanel())
            }

            if (!!additionalData[AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]) {
                dispatch(setUsersWithoutApprovers(additionalData[AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]))
            }

            if (!!additionalData[AdditionalDataConstants.WORK_ASSIGNMENTS_COUNTERS]) {
                dispatch(setWorkAssignmentsCountersForUser(createUserResult.userInfo.id, additionalData[AdditionalDataConstants.WORK_ASSIGNMENTS_COUNTERS]))
            }

            dispatch(updateStateFromCreateResult(createUserResult))
            SyncCallbacks.onUserCreated(createUserResult)
        }

        if (createUserResult.resultCode === UserManagementConstants.ERROR_NO_RIGHTS_TO_MANAGE_ACCOUNT_SETTINGS) {
            alert(messageResource.getEscapedMessage("userlist.js.error_manage_account_settings_right_revoked"))
            window.location.reload()
        }
    }).catch((error) => {
        dispatch(createActionObject(ActionTypes.SAVE_USER_FAILURE))
        if (error._providerStatus) {
            dispatch(UserDataActions.addUserPanelErrors([error._providerStatus]))
        }
        dispatch(UserDataActions.setFullUserInfo(userInfo))
    })
}

export const copyUserSettings = (userId) => (dispatch, getState) => {
    rpcCall(
        "UserManagementService.getCopyUserSettingsData", [userId],
        (error) => {
            error.handleOnException(EXCEPTIONS.NoRightsToManageAccountSettings, {_providerStatus: ValidationErrors.NO_RIGHTS})
            error.handleOnException(EXCEPTIONS.NoSuchUserException, {_providerStatus: ValidationErrors.NO_SUCH_USER})
        }
    ).then((copySettingsData) => {
        const userData = getUserDataState(getState())
        copySettingsData['fullUserInfo'] = copySettingsData['fullUserInfo']['userAccountSettings'];

        dispatch(setManageAssignments(convertManageAssignmentsToArrays(copySettingsData.userManageAssignmentsData)))

        const userGroupRowData = {
            groupId: copySettingsData.fullUserInfo.userGroupId,
            newGroupCreating: false,
        }
        const timeZoneGroupRowData = {
            groupId: copySettingsData.fullUserInfo.timeZoneGroupId,
            newGroupCreating: false,
            newTimeZoneGroup: null,
        }

        dispatch(UserDataActions.setUserData({
            ...copySettingsData,
            fullUserInfo: {
                ...pickAccountSettings(userData.fullUserInfo),
                ...pickAccountSettingFromCopyData(copySettingsData.fullUserInfo),
            },
            userGroupRowData,
            timeZoneGroupRowData,
            allApprovers: userData.approversByGroups.map[userData.fullUserInfo.userGroupId],
            userManageAssignmentsData: convertManagementAssignmentsDataFromRpc(copySettingsData.userManageAssignmentsData),
            extendedData: {
                currentTime: copySettingsData.currentTimeInUserTimeZone
            }
        }))

        dispatch(setCopyUserId(userId))
    })
     .catch((error) => {
         if (error._providerStatus === ValidationErrors.NO_RIGHTS) {
             alert(messageResource.getMessage('userlist.js.error_cant_create_user_account'));
             document.location.reload();
         }
         if (error._providerStatus === ValidationErrors.NO_SUCH_USER) {
             alert(messageResource.getEscapedMessage("userlist.js.error_no_such_user.short"));
             dispatch()//TODO delete user
         }
     })
}

const getCurrentTimeInfo = (timeZoneGroupId) => {
    return rpcCall("CurrentTimeInfoService.getCurrentTimeInfo", [timeZoneGroupId])
        .then((currentTimeInfo) => {
            return currentTimeInfo
        });
}

const pickAccountSettingsForCreateUser = (state, userInfo) => {
    let accountSettings = pickAccountSettings(userInfo)
    if (!isUGREnabled(state))
        accountSettings.userGroupId = USERS_WITHOUT_GROUP_ID
    if (!isTZGEnabled(state))
        accountSettings.timeZoneGroupId = DEFAULT_TIME_ZONE_GROUP_ID
    return accountSettings
}

const pickAccountSettings = (state) => {
    return _.pick(state, [
        'firstName',
        'lastName',
        'middleInitial',
        'username',
        'email',
        'userGroupId',
        'timeZoneGroupId',
        'hireDate',
        'releaseDate',
        'enabled',
        'enabledInOtherProduct',
        'accessRights',
        'rates',
        'requiresTTApproval',
        'overtimeLevel',
        'defaultInitialSchedule',
        'initialSchedule',
        'workSchedule',
        'password',
        'retypedPassword',
    ])
}

const pickAccountSettingFromCopyData = (settings) => {
    return {
        ..._.pick(settings, [
            'enabled',
            'enabledInOtherProduct',
            'accessRights',
            'userGroupId',
            'timeZoneGroupId',
            'overtimeLevel',
            'rates',
            'requiresTTApproval',
            'initialSchedule',
            'defaultInitialSchedule',
            'workSchedule'
        ]),
        newUserGroupName: null,
        newTimeZoneGroup: null
    }
}

const validateUserForCreate = (userInfo, userGroupData, timeZoneGroupData, providerErrors) => {
    const validationResults = [
        validateFirstName(providerErrors, userInfo.firstName),
        validateLastName(providerErrors, userInfo.lastName),
        validateEmail(providerErrors, userInfo.email, true),
        validateUserGroupName(providerErrors, userGroupData.groupId, userGroupData.newUserGroupName),
        validateTimezoneGroup(providerErrors, timeZoneGroupData.groupId, timeZoneGroupData.newTimeZoneGroup),
        validateHireDate(providerErrors, false, userInfo.hireDate),
    ]

    if (!isOlVersion) {
        validationResults.push(
            validateUserName(providerErrors, userInfo.username),
            validatePassword(providerErrors, userInfo.password),
        )
    }

    const resultErrors = validationResults.reduce((providerErrors, r) => providerErrors = {...providerErrors, ...r.errors}, {})
    return {
        isValid: $.isEmptyObject(resultErrors),
        providerErrors: resultErrors
    }
}

const validate = (validateFn, ...args) => (dispatch, getState) => {
    const state = getState()
    const providerErrors = getUserPanelErrors(state)
    const validationResult = validateFn(providerErrors, ...args)
    dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));
}

const updateUserInfo = (info) => (dispatch) => {
    dispatch(UserDataActions.setFullUserInfo(info))
}

export const updateFirstName = (newFName) => (dispatch) => {
    dispatch(updateUserInfo({firstName: newFName}))
    dispatch(validate(validateFirstName, newFName))
}

export const updateLastName = (newLName) => (dispatch) => {
    dispatch(updateUserInfo({lastName: newLName}));
    dispatch(validate(validateLastName, newLName))
}

export const updateMiddleName = (newMName) => dispatch => {
    dispatch(updateUserInfo({middleInitial: newMName}));
}

export const updateUserName = (newUName, duplicateError) => (dispatch) => {
    dispatch(updateUserInfo({username: newUName}));
    if (duplicateError) {
        dispatch(UserDataActions.addUserPanelErrors([ValidationErrors.DUPLICATE_USERNAME]))
    } else {
        dispatch(UserDataActions.removeUserPanelErrors([ValidationErrors.DUPLICATE_USERNAME]))
    }
    dispatch(validate(validateUserName, newUName))
}

export const updateEmail = (newEmail) => (dispatch) => {
    dispatch(updateUserInfo({email: newEmail}));
    dispatch(validate(validateEmail, newEmail, true))
}

export const updatePassword = (newPassword, retypedPassword) => (dispatch) => {
    dispatch(updateUserInfo({
        password: newPassword,
        retypedPassword: retypedPassword
    }));
    dispatch(setPasswordValidationRequested())
}

export const onPasswordValidationStart = () => dispatch => {
    dispatch(UserDataActions.removeUserPanelErrors([
        ValidationErrors.PASSWORD_EMPTY,
        ValidationErrors.PASSWORD_COPY_EMPTY,
        ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED,
        ValidationErrors.PASSWORDS_DO_NOT_MATCH,
    ]))
    dispatch(UserDataActions.setPasswordValidationResult(null))
}

export const onPasswordValidationEnd = (errorKey, passwordValidationJson) => dispatch => {
    if (errorKey) {
        dispatch(UserDataActions.addUserPanelErrors([errorKey]));
        dispatch(UserDataActions.setPasswordValidationResult(passwordValidationJson));
    }
    dispatch(setPasswordValidationDone())
}

export const updateUserGroup = (ugrId, newUgrName) => (dispatch) => {
    dispatch(updateUserInfo({
        userGroupId: ugrId,
    }));
    dispatch(setUserGroupData({
        groupId: ugrId,
        newGroupCreating: ugrId === GROUP_NEW_OR_NOT_KNOWN,
        newUserGroupName: newUgrName,
    }))
    dispatch(validate(validateUserGroupName, ugrId, newUgrName))
}

export const updateTimeZoneGroup = (tzgId, newTzg) => (dispatch) => {
    dispatch(UserDataActions.removeUserPanelErrors([
        ValidationErrors.DUPLICATE_TIME_ZONE_GROUP,
        ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY,
        ValidationErrors.CITY_DATA_EMPTY,
    ]))
    dispatch(updateUserInfo({
        timeZoneGroupId: tzgId,
    }));
    dispatch(setTimeZoneGroupData({
        groupId: tzgId,
        newTimeZoneGroup: newTzg,
    }))
    dispatch(validate(validateTimezoneGroup, tzgId, newTzg))
}

export const updateHireDate = (hireDate) => (dispatch) => {
    dispatch(UserDataActions.removeUserPanelErrors([ValidationErrors.LAST_MANAGER_IN_OTHER_PRODUCT]))
    dispatch(updateUserInfo({
        hireDate
    }));
    dispatch(validate(validateHireDate, false, hireDate))
}

export const updateReleaseDate = (releaseDate) => dispatch => {
    dispatch(updateUserInfo({
        releaseDate
    }));
}

export const updateUserRights = (accessRights = []) => (dispatch) => {
    dispatch(updateUserInfo({
        accessRights: accessRights
    }));
}

export const updateAccess = (enabled) => (dispatch) => {
    dispatch(updateUserInfo({
        enabled: enabled
    }));
}

export const updateAccessAP = (enabled) => (dispatch) => {
    dispatch(updateUserInfo({
        enabledInOtherProduct: enabled
    }));
}

export const updateRequireApproval = (needApproval) => dispatch => {
    dispatch(updateUserInfo({
        requiresTTApproval: needApproval
    }));
}

export const updateOvertime = (level) => (dispatch) => {
    dispatch(updateUserInfo({
        overtimeLevel: level
    }));
}

export const updateUserRates = ({index, rate}) => (dispatch, getState) => {
    const state = getState()
    const prevRates = getUserRates(state)
    const rates = [...prevRates]
    rates.splice(index, 1, rate)

    const {overtimeEnabled, leaveTypesEnabled} = getUserRatesValidationData(state)
    const {errors} = getUserRatesErrors(rates, overtimeEnabled, leaveTypesEnabled, false)

    dispatch(updateUserInfo({rates}))
    dispatch(UserRatesActions.setErrors(errors))
}

export const addNewUserRate = () => (dispatch, getState) => {
    const state = getState()
    const userRates = getUserRates(state)
    const currentDateStr = getUserManagementData(state).todayInViewerTimeZone.parseJSONDate().toJSON()

    const newRate = {
        rateId: -1,
        effectiveDate: userRates.find(rate => rate.effectiveDate === currentDateStr) ? null : currentDateStr,
        leaveRates: []
    }

    dispatch(updateUserInfo({rates: [...userRates, newRate]}));
}

export const deleteUserRate = ({index}) => (dispatch, getState) => {
    const state = getState()

    const rates = [...getUserRates(state)]
    rates.splice(index, 1)

    const errors = [...getErrors(state)]
    errors.splice(index, 1)

    dispatch(updateUserInfo({rates}))
    dispatch(UserRatesActions.setErrors(errors))
}

export const updateUserSchedules = ({workSchedules = []}) => (dispatch) => {
    dispatch(updateUserInfo({
        workSchedule: workSchedules
    }))
}

export const updateInitialUserSchedule = ({
    isDefaultInitialSchedule = false,
    initialSchedule = [],
}) => (dispatch, getState) => {
    dispatch(updateUserInfo({
        defaultInitialSchedule: isDefaultInitialSchedule,
        initialSchedule: isDefaultInitialSchedule ? getDefaultWorkSchedule(getState()) : initialSchedule,
    }))
}

export const changeTeamAssignments = ({
    teamAssignmentType = UserTeamAssignmentType.NO, assignedGroupIds = [], assignedUserIds = [],
}) => (dispatch, getState) => {
    const state = getState()

    const userTeamAssignmentsData = {
        teamAssignmentType,
        assignedGroups: assignedGroupIds,
        assignedUsers: assignedUserIds,
    }

    dispatch(UserDataActions.setUserTeamAssignmentsData({
        ...userTeamAssignmentsData,
        assignedUsersCount: getAssignedUsersCount({
            userTeamAssignmentsData,
            allUsers: getAllUsers(state),
            isUGREnabled: isUGREnabled(state),
        })
    }))
}

export const changeTasksAssignments = ({
    addedIds = [],
    removedIds = [],
    addedProjectIds = [],
    removedProjectIds = [],
    taskList = []
}) => (dispatch, getState) => {
    const state = getState()

    const tasks = getTasks(state)
    const addedIdsSet = arrayToSet(addedIds)
    const addedTasksList = Object.values(tasks).filter(task => !!addedIdsSet[task.id])
    dispatch(addTasksManageAssignments(addedTasksList))
    const tasksMap = getManageAssignmentsTasks(getState())
    const ma = {...getManageAssignments(state)}

    ma.addedProjectIdsExcludingSelf = mergeAssignments(ma.addedProjectIdsExcludingSelf, {
        added: addedProjectIds,
        removed: removedProjectIds
    })

    //  get ids of tasks already added via c or p
    const taskIdsOfCP = getTaskIdsOfCustomersAndProjects(tasks, [], addedProjectIds)

    ma.addedTaskIds = mergeAssignments(ma.addedTaskIds, {
        added: addedIds,
        removed: removedIds.concat(taskIdsOfCP),
    })

    dispatch(setManageAssignments(ma))
}

export const changeProjectAssignments = ({
    addedIds = [],
    removedIds = [],
    addedCustomerIds = [],
    removedCustomerIds = []
}) => (dispatch, getState) => {
    const state = getState()
    const tasksMap = getManageAssignmentsTasks(state)
    const ma = {...getManageAssignments(state)}

    // remove all projects of excluding self customers
    const projectsOfExcludingCustomers = getProjectIdsOfCustomers(addedCustomerIds, getProjects(state))

    ma.addedProjectIds = mergeAssignments(ma.addedProjectIds, {
        added: addedIds, removed: [...removedIds, ...projectsOfExcludingCustomers]
    })
    ma.addedProjectIdsExcludingSelf = mergeAssignments(ma.addedProjectIdsExcludingSelf, {
        added: [], removed: [...removedIds, ...addedIds, ...projectsOfExcludingCustomers]
    })
    ma.addedCustomerIdsExcludingSelf = mergeAssignments(ma.addedCustomerIdsExcludingSelf, {
        added: addedCustomerIds, removed: removedCustomerIds
    })

    // remove all tasks of excluding self customers and including self projects
    ma.addedTaskIds = mergeAssignments(ma.addedTaskIds, {
        added: [],
        removed: getTaskIdsOfCustomersAndProjects(tasksMap, addedCustomerIds, [...addedIds, ...removedIds]),
    })

    // get project counts by customers excluding self
    ma.projectCountsByCustomers = calculateProjectsByCustomerIds(ma.addedCustomerIdsExcludingSelf, getProjects(state))

    dispatch(setManageAssignments(ma))
    dispatch(UserDataActions.setUserManageAssignmentsData(
        createManagementAssignmentsData(ma, getCustomers(state), getProjects(state), tasksMap)
    ))
}

export const changeCustomerAssignments = ({
    addedIds = [],
    removedIds = []
}) => (dispatch, getState) => {
    const state = getState()
    const tasksMap = getManageAssignmentsTasks(state)
    const ma = {...getManageAssignments(state)}
    const projects = getProjects(state)

    // also remove all projects of including self customers
    const projectsOfAssignCustomers = getProjectIdsOfCustomers(addedIds, projects)
    ma.addedProjectIdsExcludingSelf = mergeAssignments(ma.addedProjectIdsExcludingSelf, {
        added: [], removed: projectsOfAssignCustomers
    })
    const projectsOfUnassignedCustomers = getProjectIdsOfCustomers(removedIds, projects)
    ma.addedProjectIds = mergeAssignments(ma.addedProjectIds, {
        added: [], removed: [...projectsOfAssignCustomers, ...projectsOfUnassignedCustomers]
    })

    ma.addedCustomerIds = mergeAssignments(ma.addedCustomerIds, {
        added: addedIds, removed: removedIds
    })
    ma.addedCustomerIdsExcludingSelf = mergeAssignments(ma.addedCustomerIdsExcludingSelf, {
        added: [], removed: removedIds
    })

    // remove all tasks of including self customers
    ma.addedTaskIds = mergeAssignments(ma.addedTaskIds, {
        added: [],
        removed: getTaskIdsOfCustomersAndProjects(tasksMap, [...addedIds, ...removedIds]),
    })

    dispatch(setManageAssignments(ma))
    dispatch(UserDataActions.setUserManageAssignmentsData(
        createManagementAssignmentsData(ma, getCustomers(state), getProjects(state), tasksMap)
    ))
}

export const changeManagementAssignmentsSelection = (managementAssignmentsSelection) => (dispatch, getState) => {
    const state = getState()
    const tasksMap = getManageAssignmentsTasks(state)
    const ma = {...getManageAssignments(state)}

    ma.managementAssignmentsSelection = managementAssignmentsSelection

    dispatch(setManageAssignments(ma))
    dispatch(UserDataActions.setUserManageAssignmentsData({
        ...createManagementAssignmentsData(ma, getCustomers(state), getProjects(state), tasksMap)
    }))
}

function getProjectIdsOfCustomers(customerIds = [], projectsMap) {
    const customerIdsSet = arrayToSet(customerIds)
    return Object.values(projectsMap).filter(project => !!customerIdsSet[project.customerId]).map(project => project.id)
}


function loadTaskCountsByProjects(projectIds = []) {
    return rpcCall('UserManagementService.countTasksByProjectsForCreateUser', [projectIds]).then(result => result.map)
}

export const loadManagementAssignmentsCounts = () => (dispatch, getState) => {
    dispatch(managementAssignmentsCountsLoad(true))

    const assignedIds = getManagementAssignmentsCptIds(getState())
    rpcCall('UserManagementService.getCptCountersForManagementAssignmentsEditor', [assignedIds])
        .then(data => {
            dispatch(managementAssignmentsCountsLoadSuccess({
                customers: data['customers'],
                projects: data['projects'],
                tasks: data['tasks']
            }))
        })
        .catch(error => dispatch(managementAssignmentsCountsLoadFailure(error)))
}

export const updateStateFromCreateResult = (result) => (dispatch) => {
    dispatch(setLicenseCounters(result.licenseCounters))
    dispatch(setViewerSettings(result.viewerSettings))
    if (result.userGroups) {
        dispatch(addUserGroups(result.userGroups))
    }
    if (result.timeZoneGroups) {
        dispatch(addTimeZoneGroups(result.timeZoneGroups))
    }

    dispatch(setEnabledFeatures(result.viewerSettings.enabledFeatures))
    dispatch(addUser(result.userInfo))
    dispatch(addNewUserIds([result.userInfo.id]))
    dispatch(prependUserIdsOrder([result.userInfo.id]))
}



// WEBPACK FOOTER //
// ./web/js/panels/user/createPanel/actions.js